import { render, staticRenderFns } from "./modifyStock.vue?vue&type=template&id=86a71a88&"
import script from "./modifyStock.vue?vue&type=script&lang=js&"
export * from "./modifyStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports